<template>
  <div v-if="order" class="container-fluid">
    <h1 class="mr-auto"><back-button to="/orders/ingredients"/>Заявка на ингредиенты</h1>
    <hr>
    <div>
      <div><strong>ФИО оператора:</strong> {{order.user | fullName}}</div>
      <div><strong>Статус:</strong> {{order.status.description}}</div>
      <div><strong>Дата оформления:</strong> {{order.date | formatDate}}</div>
    </div>

    <div class="table-full-width mt-2">
      <table class="table">
        <thead>
        <tr>
          <th colspan="2">Ингредиенты</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="component in order.request">
          <td>{{component.ingredient.name}}</td>
          <td>{{component.amount | remainder}} {{component.ingredient.measure}}</td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
  import api from '@/api'

  export default {
    metaInfo: {title: 'Заявка на ингредиенты'},
    props: {
      id: {
        required: true,
      },
    },
    data () {
      return {}
    },
    asyncComputed: {
      order () {
        return api
          .get(`orders/ingredients/${this.id}`)
          .then(({data}) => data.data)
      },
    },
  }
</script>

<style lang="scss"></style>



// WEBPACK FOOTER //
// resources/assets/js/pages/orders/ingredients/_id.vue